import { render } from "./HeroiconsOutlineChevronUp.vue?vue&type=template&id=473b34ec"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineChevronUp.vue"]])

export default __exports__